import { render, staticRenderFns } from "./UserAddTabAccount.vue?vue&type=template&id=564e6765&"
import script from "./UserAddTabAccount.vue?vue&type=script&lang=js&"
export * from "./UserAddTabAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports